import Icon from 'components/AppIcon';

const CARD_CONFIGS = {
  UPCOMING: {
    color: 'from-amber-500 to-orange-500',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    icon: 'Clock',
    label: 'Upcoming ',
    iconColor: '#f59e0b',
  },
  IN_PROGRESS: {
    color: 'from-blue-500 to-indigo-500',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    icon: 'RefreshCw',
    label: 'In Progress',
    iconColor: '#3b82f6',
  },
  ON_HOLD: {
    color: 'from-rose-500 to-pink-500',
    bg: 'bg-rose-50',
    border: 'border-rose-200',
    icon: 'PauseCircle',
    label: 'On Hold',
    iconColor: '#f43f5e',
  },
  RENEWED: {
    color: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    icon: 'CheckCircle',
    label: 'Renewed',
    iconColor: '#10b981',
  },
};

const SkeletonCard = () => (
  <div className="bg-white rounded-2xl border border-gray-200 p-5 shadow-sm animate-pulse">
    <div className="flex items-center gap-4">
      <div className="w-12 h-12 rounded-xl bg-gray-200 flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="h-3 bg-gray-200 rounded w-3/4" />
        <div className="h-7 bg-gray-200 rounded w-1/2" />
      </div>
    </div>
  </div>
);

const SummaryCards = ({ summary, isLoading }) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
        {[...Array(4)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  const cards = [
    { key: 'UPCOMING', value: summary?.upcoming ?? 0 },
    { key: 'IN_PROGRESS', value: summary?.inProgress ?? 0 },
    { key: 'ON_HOLD', value: summary?.onHold ?? 0 },
    { key: 'RENEWED', value: summary?.renewedThisMonth ?? 0 },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
      {cards.map(({ key, value }) => {
        const cfg = CARD_CONFIGS[key];
        return (
          <div
            key={key}
            className={`relative bg-white rounded-lg border ${cfg.border} p-5 shadow-sm   overflow-hidden group`}
          >
            {/* Background gradient accent */}
            {/* <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl ${cfg.color} opacity-10 rounded-full translate-x-8 -translate-y-8 group-hover:opacity-20 transition-opacity`} /> */}

            <div className="flex items-center gap-4">
              <div
                className={`w-12 h-12 ${cfg.bg} rounded-xl flex items-center justify-center flex-shrink-0`}
              >
                <Icon name={cfg.icon} size={22} color={cfg.iconColor} />
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">
                  {cfg.label}
                </p>
                <p className="text-3xl font-bold text-gray-900">{value}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryCards;
